/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashTransactionDTO,
  CashTransactionDTOOptional,
  CashTransactionDTOMetaI,
  CashTransactionDTOTrackedI,
} from "./cash-transaction-dto";
import {
  CashTransactionDTOTracked,
  CashTransactionDTOMeta,
} from "./cash-transaction-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CreateBalanceTransactionDTO,
  CreateBalanceTransactionDTOOptional,
  CreateBalanceTransactionDTOMetaI,
  CreateBalanceTransactionDTOTrackedI,
} from "./create-balance-transaction-dto";
import {
  CreateBalanceTransactionDTOTracked,
  CreateBalanceTransactionDTOMeta,
} from "./create-balance-transaction-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentDTO,
  OrderPaymentDTOOptional,
  OrderPaymentDTOMetaI,
  OrderPaymentDTOTrackedI,
} from "./order-payment-dto";
import {
  OrderPaymentDTOTracked,
  OrderPaymentDTOMeta,
} from "./order-payment-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentSourceDTO,
  PaymentSourceDTOOptional,
  PaymentSourceDTOMetaI,
  PaymentSourceDTOTrackedI,
} from "./payment-source-dto";
import {
  PaymentSourceDTOTracked,
  PaymentSourceDTOMeta,
} from "./payment-source-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentStatus,
  PaymentStatusOptional,
  PaymentStatusMetaI,
  PaymentStatusTrackedI,
} from "./payment-status";
import { PaymentStatusTracked, PaymentStatusMeta } from "./payment-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionDTO,
  StripeTransactionDTOOptional,
  StripeTransactionDTOMetaI,
  StripeTransactionDTOTrackedI,
} from "./stripe-transaction-dto";
import {
  StripeTransactionDTOTracked,
  StripeTransactionDTOMeta,
} from "./stripe-transaction-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TransactionOtherDTO,
  TransactionOtherDTOOptional,
  TransactionOtherDTOMetaI,
  TransactionOtherDTOTrackedI,
} from "./transaction-other-dto";
import {
  TransactionOtherDTOTracked,
  TransactionOtherDTOMeta,
} from "./transaction-other-dto";

/**
 *
 * @export
 * @interface CreateOrderPaymentDTO
 */
export interface CreateOrderPaymentDTOOptional extends OrderPaymentDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof CreateOrderPaymentDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof CreateOrderPaymentDTO
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {PaymentSourceDTO}
   * @memberof CreateOrderPaymentDTO
   */
  paymentSource?: PaymentSourceDTOOptional;
  /**
   *
   * @type {StripeTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  stripeTransaction?: StripeTransactionDTOOptional;
  /**
   *
   * @type {CashTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  cashTransaction?: CashTransactionDTOOptional;
  /**
   *
   * @type {CreateBalanceTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  balanceTransaction?: CreateBalanceTransactionDTOOptional;
  /**
   *
   * @type {TransactionOtherDTO}
   * @memberof CreateOrderPaymentDTO
   */
  transactionOther?: TransactionOtherDTOOptional;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdBy?: string;
  /**
   *
   * @type {OrderRef}
   * @memberof CreateOrderPaymentDTO
   */
  orderId?: OrderRefOptional;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  saveCard?: boolean;
}

export interface CreateOrderPaymentDTO
  extends CreateOrderPaymentDTOOptional, OrderPaymentDTO {
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof CreateOrderPaymentDTO
   */
  paymentType: PaymentType;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof CreateOrderPaymentDTO
   */
  paymentStatus: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {PaymentSourceDTO}
   * @memberof CreateOrderPaymentDTO
   */
  paymentSource?: PaymentSourceDTO;
  /**
   *
   * @type {StripeTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  stripeTransaction?: StripeTransactionDTO;
  /**
   *
   * @type {CashTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  cashTransaction?: CashTransactionDTO;
  /**
   *
   * @type {CreateBalanceTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  balanceTransaction?: CreateBalanceTransactionDTO;
  /**
   *
   * @type {TransactionOtherDTO}
   * @memberof CreateOrderPaymentDTO
   */
  transactionOther?: TransactionOtherDTO;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdBy?: string;
  /**
   *
   * @type {OrderRef}
   * @memberof CreateOrderPaymentDTO
   */
  orderId: OrderRef;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  saveCard?: boolean;
}

export interface CreateOrderPaymentDTOTrackedI extends OrderPaymentDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentDTO
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof CreateOrderPaymentDTO
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentRecordId?: string;
  paymentRecordIdIsSet: boolean;
  /**
   *
   * @type {PaymentStatus}
   * @memberof CreateOrderPaymentDTO
   */
  paymentStatus?: PaymentStatus;
  paymentStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentDueDate?: Date;
  paymentDueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  paymentPaidDate?: Date;
  paymentPaidDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  squarePaymentId?: string;
  squarePaymentIdIsSet: boolean;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {PaymentSourceDTO}
   * @memberof CreateOrderPaymentDTO
   */
  paymentSource?: PaymentSourceDTOTrackedI;
  paymentSourceIsSet: boolean;
  /**
   *
   * @type {StripeTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  stripeTransaction?: StripeTransactionDTOTrackedI;
  stripeTransactionIsSet: boolean;
  /**
   *
   * @type {CashTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  cashTransaction?: CashTransactionDTOTrackedI;
  cashTransactionIsSet: boolean;
  /**
   *
   * @type {CreateBalanceTransactionDTO}
   * @memberof CreateOrderPaymentDTO
   */
  balanceTransaction?: CreateBalanceTransactionDTOTrackedI;
  balanceTransactionIsSet: boolean;
  /**
   *
   * @type {TransactionOtherDTO}
   * @memberof CreateOrderPaymentDTO
   */
  transactionOther?: TransactionOtherDTOTrackedI;
  transactionOtherIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {OrderRef}
   * @memberof CreateOrderPaymentDTO
   */
  orderId?: OrderRefTrackedI;
  orderIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentDTO
   */
  saveCard?: boolean;
  saveCardIsSet: boolean;
}

transformDatesMap.set(
  "CreateOrderPaymentDTO",
  function (model: CreateOrderPaymentDTO) {
    if (typeof model.paymentCapturableDate == "string")
      model.paymentCapturableDate = new Date(model.paymentCapturableDate);
    if (typeof model.paymentDueDate == "string")
      model.paymentDueDate = new Date(model.paymentDueDate);
    if (typeof model.paymentPaidDate == "string")
      model.paymentPaidDate = new Date(model.paymentPaidDate);
    if (typeof model.expiresOn == "string")
      model.expiresOn = new Date(model.expiresOn);
    const transformDatespaymentSource =
      transformDatesMap.get("PaymentSourceDTO");
    if (transformDatespaymentSource && model.paymentSource) {
      transformDatespaymentSource(model.paymentSource);
    }
    const transformDatesstripeTransaction = transformDatesMap.get(
      "StripeTransactionDTO",
    );
    if (transformDatesstripeTransaction && model.stripeTransaction) {
      transformDatesstripeTransaction(model.stripeTransaction);
    }
    const transformDatescashTransaction =
      transformDatesMap.get("CashTransactionDTO");
    if (transformDatescashTransaction && model.cashTransaction) {
      transformDatescashTransaction(model.cashTransaction);
    }
    const transformDatesbalanceTransaction = transformDatesMap.get(
      "CreateBalanceTransactionDTO",
    );
    if (transformDatesbalanceTransaction && model.balanceTransaction) {
      transformDatesbalanceTransaction(model.balanceTransaction);
    }
    const transformDatestransactionOther = transformDatesMap.get(
      "TransactionOtherDTO",
    );
    if (transformDatestransactionOther && model.transactionOther) {
      transformDatestransactionOther(model.transactionOther);
    }
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
    const transformDatesorderId = transformDatesMap.get("OrderRef");
    if (transformDatesorderId && model.orderId) {
      transformDatesorderId(model.orderId);
    }
  },
);

export type CreateOrderPaymentDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentRecordId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentStatus: PropertyMeta<PaymentStatusMetaI>;
  //isDate: false
  //isDatetime: true
  paymentDueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  paymentPaidDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  squarePaymentId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentSource: PropertyMeta<PaymentSourceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  stripeTransaction: PropertyMeta<StripeTransactionDTOMetaI>;
  //isDate: false
  //isDatetime: false
  cashTransaction: PropertyMeta<CashTransactionDTOMetaI>;
  //isDate: false
  //isDatetime: false
  balanceTransaction: PropertyMeta<CreateBalanceTransactionDTOMetaI>;
  //isDate: false
  //isDatetime: false
  transactionOther: PropertyMeta<TransactionOtherDTOMetaI>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<OrderRefMetaI>;
  //isDate: false
  //isDatetime: false
  saveCard: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var CreateOrderPaymentDTOMeta: CreateOrderPaymentDTOMetaI =
  {} as CreateOrderPaymentDTOMetaI;
CreateOrderPaymentDTOMeta = typeMeta("CreateOrderPaymentDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentType: propertyMeta("paymentType", false, true, false, PaymentTypeMeta),
  paymentRecordId: propertyMeta(
    "paymentRecordId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  paymentStatus: propertyMeta(
    "paymentStatus",
    false,
    true,
    false,
    PaymentStatusMeta,
  ),
  paymentDueDate: propertyMeta(
    "paymentDueDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidDate: propertyMeta(
    "paymentPaidDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  squarePaymentId: propertyMeta(
    "squarePaymentId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  paymentSource: propertyMeta(
    "paymentSource",
    false,
    false,
    false,
    PaymentSourceDTOMeta,
  ),
  stripeTransaction: propertyMeta(
    "stripeTransaction",
    false,
    false,
    false,
    StripeTransactionDTOMeta,
  ),
  cashTransaction: propertyMeta(
    "cashTransaction",
    false,
    false,
    false,
    CashTransactionDTOMeta,
  ),
  balanceTransaction: propertyMeta(
    "balanceTransaction",
    false,
    false,
    false,
    CreateBalanceTransactionDTOMeta,
  ),
  transactionOther: propertyMeta(
    "transactionOther",
    false,
    false,
    false,
    TransactionOtherDTOMeta,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  orderId: propertyMeta("orderId", false, true, false, OrderRefMeta),
  saveCard: propertyMeta(
    "saveCard",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = CreateOrderPaymentDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentDTOMeta]);
  metaI.isDeleted.inheritedFrom = OrderPaymentDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = OrderPaymentDTOMeta.isNew;
  metaI.assignId.inheritedFrom = OrderPaymentDTOMeta.assignId;
  metaI.paymentServiceChangeCents.inheritedFrom =
    OrderPaymentDTOMeta.paymentServiceChangeCents;
  metaI.paymentCapturableCents.inheritedFrom =
    OrderPaymentDTOMeta.paymentCapturableCents;
  metaI.paymentCapturableDate.inheritedFrom =
    OrderPaymentDTOMeta.paymentCapturableDate;
  metaI.paymentPaidCents.inheritedFrom = OrderPaymentDTOMeta.paymentPaidCents;
  metaI.paymentTotalCents.inheritedFrom = OrderPaymentDTOMeta.paymentTotalCents;
  metaI.paymentRefundedCents.inheritedFrom =
    OrderPaymentDTOMeta.paymentRefundedCents;
  metaI.paymentToRefundCents.inheritedFrom =
    OrderPaymentDTOMeta.paymentToRefundCents;
  metaI.paymentType.inheritedFrom = OrderPaymentDTOMeta.paymentType;
  metaI.paymentRecordId.inheritedFrom = OrderPaymentDTOMeta.paymentRecordId;
  metaI.paymentStatus.inheritedFrom = OrderPaymentDTOMeta.paymentStatus;
  metaI.paymentDueDate.inheritedFrom = OrderPaymentDTOMeta.paymentDueDate;
  metaI.paymentPaidDate.inheritedFrom = OrderPaymentDTOMeta.paymentPaidDate;
  metaI.squarePaymentId.inheritedFrom = OrderPaymentDTOMeta.squarePaymentId;
  metaI.expiresOn.inheritedFrom = OrderPaymentDTOMeta.expiresOn;
  metaI.paymentSource.inheritedFrom = OrderPaymentDTOMeta.paymentSource;
  metaI.stripeTransaction.inheritedFrom = OrderPaymentDTOMeta.stripeTransaction;
  metaI.cashTransaction.inheritedFrom = OrderPaymentDTOMeta.cashTransaction;
  metaI.balanceTransaction.inheritedFrom =
    OrderPaymentDTOMeta.balanceTransaction;
  metaI.transactionOther.inheritedFrom = OrderPaymentDTOMeta.transactionOther;
  metaI.updatedOn.inheritedFrom = OrderPaymentDTOMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = OrderPaymentDTOMeta.updatedBy;
  metaI.createdOn.inheritedFrom = OrderPaymentDTOMeta.createdOn;
  metaI.createdBy.inheritedFrom = OrderPaymentDTOMeta.createdBy;
});

export class CreateOrderPaymentDTOTracked
  extends OrderPaymentDTOTracked
  implements CreateOrderPaymentDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentRecordId__I?: string = undefined;
  paymentRecordIdIsSet: boolean = false;
  set paymentRecordId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentRecordId__I = v;
      this.paymentRecordIdIsSet = true;
    } else {
      this.paymentRecordId__I = v || undefined;
      this.paymentRecordIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRecordId() {
    return this.paymentRecordId__I;
  }
  paymentStatus__I?: PaymentStatus = undefined;
  paymentStatusIsSet: boolean = false;
  set paymentStatus(v: undefined | PaymentStatus) {
    if (v !== undefined) {
      this.paymentStatus__I = v;
      this.paymentStatusIsSet = true;
    } else {
      this.paymentStatus__I = v || undefined;
      this.paymentStatusIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentStatus() {
    return this.paymentStatus__I;
  }
  paymentDueDate__I?: Date = undefined;
  paymentDueDateIsSet: boolean = false;
  set paymentDueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentDueDate__I = v;
      this.paymentDueDateIsSet = true;
    } else {
      this.paymentDueDate__I = v || undefined;
      this.paymentDueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDueDate() {
    return this.paymentDueDate__I;
  }
  paymentPaidDate__I?: Date = undefined;
  paymentPaidDateIsSet: boolean = false;
  set paymentPaidDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentPaidDate__I = v;
      this.paymentPaidDateIsSet = true;
    } else {
      this.paymentPaidDate__I = v || undefined;
      this.paymentPaidDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidDate() {
    return this.paymentPaidDate__I;
  }
  squarePaymentId__I?: string = undefined;
  squarePaymentIdIsSet: boolean = false;
  set squarePaymentId(v: undefined | string) {
    if (v !== undefined) {
      this.squarePaymentId__I = v;
      this.squarePaymentIdIsSet = true;
    } else {
      this.squarePaymentId__I = v || undefined;
      this.squarePaymentIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squarePaymentId() {
    return this.squarePaymentId__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  paymentSource__I?: PaymentSourceDTOTracked = undefined;
  paymentSourceIsSet: boolean = false;
  set paymentSource(v: undefined | PaymentSourceDTOTracked) {
    if (v !== undefined) {
      this.paymentSource__I = v;
      this.paymentSourceIsSet = true;
    } else {
      this.paymentSource__I = v || undefined;
      this.paymentSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentSource() {
    return this.paymentSource__I;
  }
  stripeTransaction__I?: StripeTransactionDTOTracked = undefined;
  stripeTransactionIsSet: boolean = false;
  set stripeTransaction(v: undefined | StripeTransactionDTOTracked) {
    if (v !== undefined) {
      this.stripeTransaction__I = v;
      this.stripeTransactionIsSet = true;
    } else {
      this.stripeTransaction__I = v || undefined;
      this.stripeTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripeTransaction() {
    return this.stripeTransaction__I;
  }
  cashTransaction__I?: CashTransactionDTOTracked = undefined;
  cashTransactionIsSet: boolean = false;
  set cashTransaction(v: undefined | CashTransactionDTOTracked) {
    if (v !== undefined) {
      this.cashTransaction__I = v;
      this.cashTransactionIsSet = true;
    } else {
      this.cashTransaction__I = v || undefined;
      this.cashTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashTransaction() {
    return this.cashTransaction__I;
  }
  balanceTransaction__I?: CreateBalanceTransactionDTOTracked = undefined;
  balanceTransactionIsSet: boolean = false;
  set balanceTransaction(v: undefined | CreateBalanceTransactionDTOTracked) {
    if (v !== undefined) {
      this.balanceTransaction__I = v;
      this.balanceTransactionIsSet = true;
    } else {
      this.balanceTransaction__I = v || undefined;
      this.balanceTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceTransaction() {
    return this.balanceTransaction__I;
  }
  transactionOther__I?: TransactionOtherDTOTracked = undefined;
  transactionOtherIsSet: boolean = false;
  set transactionOther(v: undefined | TransactionOtherDTOTracked) {
    if (v !== undefined) {
      this.transactionOther__I = v;
      this.transactionOtherIsSet = true;
    } else {
      this.transactionOther__I = v || undefined;
      this.transactionOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionOther() {
    return this.transactionOther__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  orderId__I?: OrderRefTracked = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | OrderRefTracked) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  saveCard__I?: boolean = undefined;
  saveCardIsSet: boolean = false;
  set saveCard(v: undefined | boolean) {
    if (v !== undefined) {
      this.saveCard__I = v;
      this.saveCardIsSet = true;
    } else {
      this.saveCard__I = v || undefined;
      this.saveCardIsSet = false;
    }
    this.changeTracker = true;
  }
  get saveCard() {
    return this.saveCard__I;
  }
  constructor(config?: CreateOrderPaymentDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.paymentSource?.setIds();

    this.stripeTransaction?.setIds();

    this.cashTransaction?.setIds();

    this.balanceTransaction?.setIds();

    this.transactionOther?.setIds();

    this.orderId?.setIds();
  }
  assignFrom(
    config: CreateOrderPaymentDTOOptional,
    options?: AssignOptions,
  ): CreateOrderPaymentDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentRecordId &&
      this.paymentRecordIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRecordId = config.paymentRecordId;
      if (optionsRequired.unassign) this.paymentRecordIdIsSet = false;
      else this.paymentRecordIdIsSet = true;
    }
    if (
      config.paymentStatus &&
      this.paymentStatusApplyFilter(optionsRequired.filter)
    ) {
      this.paymentStatus = config.paymentStatus;
      if (optionsRequired.unassign) this.paymentStatusIsSet = false;
      else this.paymentStatusIsSet = true;
    }
    if (
      config.paymentDueDate &&
      this.paymentDueDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDueDate = config.paymentDueDate;
      if (optionsRequired.unassign) this.paymentDueDateIsSet = false;
      else this.paymentDueDateIsSet = true;
    }
    if (
      config.paymentPaidDate &&
      this.paymentPaidDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidDate = config.paymentPaidDate;
      if (optionsRequired.unassign) this.paymentPaidDateIsSet = false;
      else this.paymentPaidDateIsSet = true;
    }
    if (
      config.squarePaymentId &&
      this.squarePaymentIdApplyFilter(optionsRequired.filter)
    ) {
      this.squarePaymentId = config.squarePaymentId;
      if (optionsRequired.unassign) this.squarePaymentIdIsSet = false;
      else this.squarePaymentIdIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (
      config.paymentSource &&
      this.paymentSourceApplyFilter(optionsRequired.filter)
    ) {
      this.paymentSource = new PaymentSourceDTOTracked(
        config.paymentSource,
        options,
      );
      if (optionsRequired.unassign) this.paymentSourceIsSet = false;
      else this.paymentSourceIsSet = true;
    }
    if (
      config.stripeTransaction &&
      this.stripeTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.stripeTransaction = new StripeTransactionDTOTracked(
        config.stripeTransaction,
        options,
      );
      if (optionsRequired.unassign) this.stripeTransactionIsSet = false;
      else this.stripeTransactionIsSet = true;
    }
    if (
      config.cashTransaction &&
      this.cashTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.cashTransaction = new CashTransactionDTOTracked(
        config.cashTransaction,
        options,
      );
      if (optionsRequired.unassign) this.cashTransactionIsSet = false;
      else this.cashTransactionIsSet = true;
    }
    if (
      config.balanceTransaction &&
      this.balanceTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.balanceTransaction = new CreateBalanceTransactionDTOTracked(
        config.balanceTransaction,
        options,
      );
      if (optionsRequired.unassign) this.balanceTransactionIsSet = false;
      else this.balanceTransactionIsSet = true;
    }
    if (
      config.transactionOther &&
      this.transactionOtherApplyFilter(optionsRequired.filter)
    ) {
      this.transactionOther = new TransactionOtherDTOTracked(
        config.transactionOther,
        options,
      );
      if (optionsRequired.unassign) this.transactionOtherIsSet = false;
      else this.transactionOtherIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = new OrderRefTracked(config.orderId, options);
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (config.saveCard && this.saveCardApplyFilter(optionsRequired.filter)) {
      this.saveCard = config.saveCard;
      if (optionsRequired.unassign) this.saveCardIsSet = false;
      else this.saveCardIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CreateOrderPaymentDTOTrackedI {
    const cloned = {} as CreateOrderPaymentDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentRecordIdIsSetDeep() &&
      this.paymentRecordIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRecordIdIsSet = true;
      cloned.paymentRecordId = this.paymentRecordId;
    } else {
      //cloned.paymentRecordIdIsSet = false
    }
    if (
      this.paymentStatusIsSetDeep() &&
      this.paymentStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentStatusIsSet = true;
      cloned.paymentStatus = this.paymentStatus;
    } else {
      //cloned.paymentStatusIsSet = false
    }
    if (
      this.paymentDueDateIsSetDeep() &&
      this.paymentDueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDueDateIsSet = true;
      cloned.paymentDueDate = this.paymentDueDate;
    } else {
      //cloned.paymentDueDateIsSet = false
    }
    if (
      this.paymentPaidDateIsSetDeep() &&
      this.paymentPaidDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidDateIsSet = true;
      cloned.paymentPaidDate = this.paymentPaidDate;
    } else {
      //cloned.paymentPaidDateIsSet = false
    }
    if (
      this.squarePaymentIdIsSetDeep() &&
      this.squarePaymentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squarePaymentIdIsSet = true;
      cloned.squarePaymentId = this.squarePaymentId;
    } else {
      //cloned.squarePaymentIdIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.paymentSourceIsSetDeep() &&
      this.paymentSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentSourceIsSet = true;
      cloned.paymentSource = this.paymentSource?.removeUnset(filter);
    } else {
      //cloned.paymentSourceIsSet = false
    }
    if (
      this.stripeTransactionIsSetDeep() &&
      this.stripeTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripeTransactionIsSet = true;
      cloned.stripeTransaction = this.stripeTransaction?.removeUnset(filter);
    } else {
      //cloned.stripeTransactionIsSet = false
    }
    if (
      this.cashTransactionIsSetDeep() &&
      this.cashTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashTransactionIsSet = true;
      cloned.cashTransaction = this.cashTransaction?.removeUnset(filter);
    } else {
      //cloned.cashTransactionIsSet = false
    }
    if (
      this.balanceTransactionIsSetDeep() &&
      this.balanceTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTransactionIsSet = true;
      cloned.balanceTransaction = this.balanceTransaction?.removeUnset(filter);
    } else {
      //cloned.balanceTransactionIsSet = false
    }
    if (
      this.transactionOtherIsSetDeep() &&
      this.transactionOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionOtherIsSet = true;
      cloned.transactionOther = this.transactionOther?.removeUnset(filter);
    } else {
      //cloned.transactionOtherIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId?.removeUnset(filter);
    } else {
      //cloned.orderIdIsSet = false
    }
    if (
      this.saveCardIsSetDeep() &&
      this.saveCardApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.saveCardIsSet = true;
      cloned.saveCard = this.saveCard;
    } else {
      //cloned.saveCardIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CreateOrderPaymentDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentRecordIdApplyFilter(filter))
      this.paymentRecordIdIsSet = false;

    if (!this.paymentStatusApplyFilter(filter)) this.paymentStatusIsSet = false;

    if (!this.paymentDueDateApplyFilter(filter))
      this.paymentDueDateIsSet = false;

    if (!this.paymentPaidDateApplyFilter(filter))
      this.paymentPaidDateIsSet = false;

    if (!this.squarePaymentIdApplyFilter(filter))
      this.squarePaymentIdIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.paymentSourceApplyFilter(filter)) this.paymentSourceIsSet = false;
    this.paymentSource?.unassignAll(filter);

    if (!this.stripeTransactionApplyFilter(filter))
      this.stripeTransactionIsSet = false;
    this.stripeTransaction?.unassignAll(filter);

    if (!this.cashTransactionApplyFilter(filter))
      this.cashTransactionIsSet = false;
    this.cashTransaction?.unassignAll(filter);

    if (!this.balanceTransactionApplyFilter(filter))
      this.balanceTransactionIsSet = false;
    this.balanceTransaction?.unassignAll(filter);

    if (!this.transactionOtherApplyFilter(filter))
      this.transactionOtherIsSet = false;
    this.transactionOther?.unassignAll(filter);

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;
    this.orderId?.unassignAll(filter);

    if (!this.saveCardApplyFilter(filter)) this.saveCardIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.isDeleted,
      CreateOrderPaymentDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.isNew,
      CreateOrderPaymentDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.assignId,
      CreateOrderPaymentDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentServiceChangeCents,
      CreateOrderPaymentDTOMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentCapturableCents,
      CreateOrderPaymentDTOMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentCapturableDate,
      CreateOrderPaymentDTOMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentPaidCents,
      CreateOrderPaymentDTOMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentTotalCents,
      CreateOrderPaymentDTOMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentRefundedCents,
      CreateOrderPaymentDTOMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentToRefundCents,
      CreateOrderPaymentDTOMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentType,
      CreateOrderPaymentDTOMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentRecordIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentRecordId,
      CreateOrderPaymentDTOMeta,
      this.paymentRecordId,
      this,
    );
  }
  paymentRecordIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentRecordIdIsSet && this.paymentRecordIdApplyFilter(filter))
      return true;

    return false;
  }
  paymentStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentStatus,
      CreateOrderPaymentDTOMeta,
      this.paymentStatus,
      this,
    );
  }
  paymentStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentStatusIsSet && this.paymentStatusApplyFilter(filter))
      return true;

    return false;
  }
  paymentDueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentDueDate,
      CreateOrderPaymentDTOMeta,
      this.paymentDueDate,
      this,
    );
  }
  paymentDueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentDueDateIsSet && this.paymentDueDateApplyFilter(filter))
      return true;

    return false;
  }
  paymentPaidDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentPaidDate,
      CreateOrderPaymentDTOMeta,
      this.paymentPaidDate,
      this,
    );
  }
  paymentPaidDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidDateIsSet && this.paymentPaidDateApplyFilter(filter))
      return true;

    return false;
  }
  squarePaymentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.squarePaymentId,
      CreateOrderPaymentDTOMeta,
      this.squarePaymentId,
      this,
    );
  }
  squarePaymentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squarePaymentIdIsSet && this.squarePaymentIdApplyFilter(filter))
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.expiresOn,
      CreateOrderPaymentDTOMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  paymentSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.paymentSource,
      CreateOrderPaymentDTOMeta,
      this.paymentSource,
      this,
    );
  }
  paymentSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentSourceIsSet && this.paymentSourceApplyFilter(filter))
      return true;
    return this.paymentSource?.anySet(filter) == true;

    return false;
  }
  stripeTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.stripeTransaction,
      CreateOrderPaymentDTOMeta,
      this.stripeTransaction,
      this,
    );
  }
  stripeTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripeTransactionIsSet &&
      this.stripeTransactionApplyFilter(filter)
    )
      return true;
    return this.stripeTransaction?.anySet(filter) == true;

    return false;
  }
  cashTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.cashTransaction,
      CreateOrderPaymentDTOMeta,
      this.cashTransaction,
      this,
    );
  }
  cashTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashTransactionIsSet && this.cashTransactionApplyFilter(filter))
      return true;
    return this.cashTransaction?.anySet(filter) == true;

    return false;
  }
  balanceTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.balanceTransaction,
      CreateOrderPaymentDTOMeta,
      this.balanceTransaction,
      this,
    );
  }
  balanceTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceTransactionIsSet &&
      this.balanceTransactionApplyFilter(filter)
    )
      return true;
    return this.balanceTransaction?.anySet(filter) == true;

    return false;
  }
  transactionOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.transactionOther,
      CreateOrderPaymentDTOMeta,
      this.transactionOther,
      this,
    );
  }
  transactionOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionOtherIsSet && this.transactionOtherApplyFilter(filter))
      return true;
    return this.transactionOther?.anySet(filter) == true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.updatedOn,
      CreateOrderPaymentDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.updatedBy,
      CreateOrderPaymentDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.createdOn,
      CreateOrderPaymentDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.createdBy,
      CreateOrderPaymentDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.orderId,
      CreateOrderPaymentDTOMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;
    return this.orderId?.anySet(filter) == true;

    return false;
  }
  saveCardApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentDTOMeta.saveCard,
      CreateOrderPaymentDTOMeta,
      this.saveCard,
      this,
    );
  }
  saveCardIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.saveCardIsSet && this.saveCardApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentRecordIdIsSetDeep(filter)) return true;
    if (this.paymentStatusIsSetDeep(filter)) return true;
    if (this.paymentDueDateIsSetDeep(filter)) return true;
    if (this.paymentPaidDateIsSetDeep(filter)) return true;
    if (this.squarePaymentIdIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.paymentSourceIsSetDeep(filter)) return true;
    if (this.stripeTransactionIsSetDeep(filter)) return true;
    if (this.cashTransactionIsSetDeep(filter)) return true;
    if (this.balanceTransactionIsSetDeep(filter)) return true;
    if (this.transactionOtherIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    if (this.saveCardIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
